export default "__VITE_ASSET__BQkwh1Dv__"